import React from "react";

import { request } from "../../api";

import styles from "./Awards.module.scss";

const Awards = ({ title, list }) => {
  return (
    <div className={styles.Awards}>
      <h2 className={"h2-title title-with-mrg"}>{title}</h2>

      <ul className={styles.List}>
        {list.map((award) => {
          const logoPath = award.image.thumb.url || award.image.url;

          if (!logoPath) {
            return null;
          }

          return (
            <li className={styles.Item} key={award.id}>
              <img
                className={styles.Logo}
                src={award.image?.url ? `${request}/${logoPath}` : ""}
                alt={award.name}
              />

              <span
                className={styles.Name}
                dangerouslySetInnerHTML={{ __html: award.name }}
              ></span>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default Awards;
